<template>
  <div class="line-stats">
    <div data-test="statisticItem-image"><img :alt="attribute" :src="require(`@/assets/iconsStats/${filename}`)" width="18px" /><span>{{ label }}</span> : </div>
    <div data-test="statisticItem-value"><strong>{{ value }}</strong></div>
  </div>
</template>

<script>
export default {
  name: 'StatisticItem',
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: [Number, String],
      required: true
    },
    attribute: {
      type: String,
      required: true
    },
    filename: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
strong {
  color: #00a4bd;
  font-weight: 600;
}
.line-stats{
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  font-family: "Dosis", Helvetica, Arial, sans-serif;
  font-size: 15px;
}
span{
  margin-left: 10px;
}
</style>
